import React from 'react';
import _ from 'lodash';
import { Map, List } from 'immutable';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import { Modal, Button, ButtonToolbar, TabbedArea, TabPane } from 'react-bootstrap';

import { SubTitle } from '../../components';
import { ModalsStore } from '../../stores';
import { ModalsAction } from '../../actions';

ModalsStore.initialize();

export default class YesNoDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id        : this.props.id,
      isVisible : this.props.isVisible,
      payload   : Map(),
      isLoading : false
    };

    ModalsAction.add(this.props.id)

    this.handleChange   = this.handleChange.bind(this)
    this.handleYesClick = this.handleYesClick.bind(this)
    this.handleNoClick  = this.handleNoClick.bind(this)
    this.getMessage     = this.getMessage.bind(this)
    this.keyPress       = this.keyPress.bind(this);
  }

  componentDidMount() {
    ModalsStore.addChangeListener(this.handleChange);
    document.addEventListener('keyup', this.keyPress, false);
  }

  componentWillUnmount() {
    ModalsStore.removeChangeListener(this.handleChange);
    document.removeEventListener('keyup', this.keyPress);
  }

  keyPress(e){
    if(this.state.isVisible) {
      if(e.keyCode === 13)
        this.handleYesClick()
    }
  }

  render(){
    return (<Modal
                show    ={this.state.isVisible}
                payload ={this.state.payload}
                onHide  ={this.state.isLoading ? null : this.props.onNo}
                icon    ={this.props.icon}>
      <Modal.Header closeButton={!this.state.isLoading}>
        <SubTitle>{this.props.title}</SubTitle>
      </Modal.Header>
      <Modal.Body>
        {this.state.isLoading ? (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <div className="text-center">
              <i className="fa fa-spinner fa-spin fa-3x" style={{ color: '#337ab7', marginBottom: '15px' }}></i>
              <p style={{ fontSize: '16px', color: '#555' }}>
                Price alerts are being recalculated...
              </p>
              <p style={{ fontSize: '14px', color: '#888' }}>
                Please wait, this may take a few moments.
              </p>
            </div>
          </div>
        ) : (
          <div>
            {this.getMessage()}
            <ButtonToolbar style={{'textAlign': 'right'}}>
              <Button bsStyle='danger' onClick={this.handleNoClick}>No</Button>
              <Button bsStyle='success' onClick={this.handleYesClick}>Yes</Button>
            </ButtonToolbar>
          </div>
        )}
      </Modal.Body>
    </Modal>)
  }

  getMessage(){
    var _msg = "Are you sure you want to delete ";

    if(this.props.children) {
      return this.props.children;
    } else if (!_.isUndefined(this.state.payload) && !_.isUndefined(this.state.payload.get('message'))) {
      return this.state.payload.get('message');
    } else if(!_.isUndefined(this.state.payload) && !_.isUndefined(this.state.payload.get('name'))) {
      return  _msg + this.state.payload.get('name');
    } else {
      return 'Are you sure you want to continue ?'
    }
  }

  handleYesClick(){
    // Set loading state before calling the callback (only if prop is enabled)
    if (this.props.showLoadingOnConfirm) {
      this.setState({ isLoading: true });
    }
    this.props.onYes(this.state.payload);
  }

  handleNoClick(){
    if (!this.state.isLoading) {
      this.props.onNo(this.state.payload);
    }
  }

  handleChange(){
    const wasLoading = this.state.isLoading;
    const isNowVisible = ModalsStore.isModalVisible(this.props.id);
    const isNowLoading = !isNowVisible ? false : this.state.isLoading;
    
    this.setState({
      isVisible: isNowVisible,
      payload  : ModalsStore.getPayload(this.props.id),
      isLoading: isNowLoading
    });
    
    // If was loading and now closing the modal, call onComplete callback
    if (wasLoading && !isNowVisible && this.props.onComplete) {
      this.props.onComplete();
    }
  }
}
YesNoDialog.propTypes    = {
  id         : React.PropTypes.number,
  isVisible  : React.PropTypes.bool,
  payload    : React.PropTypes.object,
  icon       : React.PropTypes.string,
  showLoadingOnConfirm: React.PropTypes.bool,
  onComplete : React.PropTypes.func,
}
YesNoDialog.defaultProps    = {
  isVisible  : false,
  icon       : null,
  payload    : {},
  showLoadingOnConfirm: false
}